window.actualizarModalReporteAcondicionamiento = null;

if (window.location.pathname === "/acondicionamiento/periodo" || window.location.pathname === "/zona-trabajo") {

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const num = n => (Number(n) || 0).toLocaleString('en-US');
    const fecha = f => { if (!f) return ''; return f.split('-').reverse().join('/'); };
    const txt = t => (t === null || t === undefined || String(t).trim() === '') ? '-' : String(t);
    const idReporteAcondicionamiento = item => {
        if (!item) return '';
        return item.idEncabezadoReporteAcondicionamiento
            ?? item.idencabezadoreporteacondicionamiento
            ?? item.idEncabezadoReporte
            ?? item.idencabezadoreporte
            ?? '';
    };

    const set = (id, value) => {
        const el = document.getElementById(id);
        if (!el) return;
        if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') {
            el.value = (value === null || value === undefined) ? '' : value;
        } else {
            el.textContent = (value === null || value === undefined) ? '' : value;
        }
    };

    const mostrarEl = el => { if (el) el.style.display = ''; };
    const ocultarEl = el => { if (el) el.style.display = 'none'; };

    const escapeHtml = (str) => {
        str = str === null || str === undefined ? '' : String(str);
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    };

    window.actualizarModalReporteAcondicionamiento = function (id) {
        const modal = document.querySelector('#modalProduccionAcondicionamiento');
        if (!modal) return;

        const url = `/api/acondicionamiento/infoReporte?idReporte=${id}`;

        fetch(url, requestOptions)
            .then(function (response) {
                if (!response.ok) throw new Error('Error HTTP: ' + response.status);
                return response.json();
            })
            .then(function (result) {
                const data = result.result;
                if (!data || !data.encabezado) return;

                const encabezado = data.encabezado;
                const equipo = data.equipo || [];
                const lineas = data.lineas || [];
                const resumen = data.resumen || {};
                const infoUsuario = data.infoUsuario || {};
                const rol = Number(infoUsuario.idRol) || 0;
                const esAdmin = rol === 1;
                const esConsultor = rol === 3;
                const reporteActivo = Number(encabezado.estado) === 1;
                const reporteFinalizado = Number(encabezado.estado) === 2;

                const idEncabezado = idReporteAcondicionamiento(encabezado) || id;

                set('idReporteAcondicionamiento', idEncabezado);
                set('tituloModalAcondicionamiento', 'OF ' + (encabezado.numeroOf || '') + ' - ' + (encabezado.nombreActividad || '') + ' - ' + fecha(encabezado.fechaTrabajo));

                // ── Información general (ficha de solo lectura) ──────────────────
                set('fechaTrabajoInfoAcondicionamiento', fecha(encabezado.fechaTrabajo));
                set('numeroOfInfoAcondicionamiento', txt(encabezado.numeroOf));
                set('numeroPedidoInfoAcondicionamiento', txt(encabezado.numeroPedido));
                set('cmnClienteInfoAcondicionamiento', txt(encabezado.codigoSap));
                set('nombreClienteInfoAcondicionamiento', txt(encabezado.nombreSap));
                set('codigoArticuloInfoAcondicionamiento', txt(encabezado.codigoArticulo));
                set('descripcionArticuloInfoAcondicionamiento', txt(encabezado.descripcionArticulo));
                set('loteImportacionInfoAcondicionamiento', txt(encabezado.loteImportacion));
                set('loteTrabajoInfoAcondicionamiento', txt(encabezado.loteTrabajo));
                set('nombreActividadInfoAcondicionamiento', txt(encabezado.nombreActividad));
                set('detalleActividadInfoAcondicionamiento', txt(encabezado.detalleActividad));
                set('unidadesRequeridasInfoAcondicionamiento', num(encabezado.unidadesRequeridas));
                set('cantidadRecibidaInfoAcondicionamiento', num(encabezado.cantidadRecibida));
                set('cantidadDespachoInfoAcondicionamiento', num(encabezado.cantidadDespacho));
                set('nombreCreadoPorInfoAcondicionamiento', txt(encabezado.nombreCreadoPor));
                set('observacionesInfoAcondicionamiento', txt(encabezado.observaciones));

                const estadoInfo = document.getElementById('estadoInfoAcondicionamiento');
                if (estadoInfo) {
                    estadoInfo.textContent = reporteActivo ? 'ACTIVO' : 'FINALIZADO';
                    estadoInfo.className = reporteActivo ? 'tdVerde' : 'tdGris';
                }

                // ── Botones superiores ────────────────────────────────────────────
                const btnAbrirOrden = document.getElementById('btnAbrirOrdenTrabajoAcondicionamiento');
                const btnReactivar = document.getElementById('btnReactivarReporteAcondicionamiento');
                const btnFinalizar = document.getElementById('btnModalFinalizarReporteAcondicionamiento');
                const btnDuplicar = document.getElementById('btnDuplicarReporteAcondicionamiento');
                const btnEliminar = document.getElementById('btnEliminarReporteAcondicionamiento');
                ocultarEl(btnAbrirOrden);
                ocultarEl(btnReactivar);
                ocultarEl(btnFinalizar);
                ocultarEl(btnDuplicar);
                ocultarEl(btnEliminar);
                if (!reporteActivo) {
                    mostrarEl(btnAbrirOrden);
                }
                if (reporteFinalizado && esAdmin) {
                    if (btnReactivar) btnReactivar.setAttribute('data-id', idEncabezado);
                    mostrarEl(btnReactivar);
                }
                if (reporteActivo && !esConsultor) {
                    mostrarEl(btnFinalizar);
                }
                if (esAdmin) {
                    if (btnDuplicar) btnDuplicar.setAttribute('data-id', idEncabezado);
                    mostrarEl(btnDuplicar);
                    if (reporteActivo) {
                        if (btnEliminar) btnEliminar.setAttribute('data-id', idEncabezado);
                        mostrarEl(btnEliminar);
                    }
                }

                // ── Equipo de trabajo (solo lectura, se define al crear la orden) ─
                const contEquipo = document.getElementById('contEquipoTrabajoAcondicionamiento');
                if (contEquipo) {
                    if (equipo.length === 0) {
                        contEquipo.innerHTML = '<p class="sinDatos">Sin operarios asignados.</p>';
                    } else {
                        let htmlEquipo = '';
                        equipo.forEach(function (item) {
                            htmlEquipo += '<article class="cardPersonal">' +
                                '<div class="cardPersonalAvatar">' +
                                '<img class="imgColaborador" src="/public/uploads/usuarios/' + encodeURIComponent(item.fotoUsuario || '') + '?v=' + Date.now() + '" alt="operario">' +
                                '</div>' +
                                '<div class="cardPersonalBody">' +
                                '<p class="cardPersonalRole">' + escapeHtml(item.nombreCargo) + '</p>' +
                                '<p class="cardPersonalName">' + escapeHtml(item.nombreCompletoUsuario) + '</p>' +
                                '</div>' +
                                '</article>';
                        });
                        contEquipo.innerHTML = htmlEquipo;
                    }
                }

                // ── Tabulación ────────────────────────────────────────────────────
                const btnAgregarTabulacion = document.getElementById('btnAgregarTabulacionAcondicionamiento');
                if (reporteActivo && !esConsultor) mostrarEl(btnAgregarTabulacion); else ocultarEl(btnAgregarTabulacion);

                const tbody = document.getElementById('tbodyTabulacionAcondicionamiento');
                if (tbody) {
                    if (lineas.length === 0) {
                        tbody.innerHTML = '<tr class="no-data"><td colspan="9"><div class="cont-no-data">No hay registros de producción para este reporte.</div></td></tr>';
                    } else {
                        let htmlLineas = '';
                        lineas.forEach(function (linea) {
                            const puedeEditar = reporteActivo && !esConsultor && (esAdmin || linea.esPropio);
                            let acciones = '';
                            if (puedeEditar) {
                                acciones =
                                    '<button type="button" class="btnEditarTabulacionAcondicionamiento" data-id="' + linea.idLineaReporteAcondicionamiento + '"' +
                                    ' data-hora-inicio="' + escapeHtml(linea.horaInicio) + '"' +
                                    ' data-hora-fin="' + escapeHtml(linea.horaFin) + '"' +
                                    ' data-cantidad-trabajada="' + escapeHtml(linea.cantidadTrabajada) + '"' +
                                    ' data-unidades-buenas="' + escapeHtml(linea.unidadesBuenas) + '"' +
                                    ' data-unidades-otra="' + escapeHtml(linea.unidadesOtraDisposicion) + '"' +
                                    ' data-unidades-malas="' + escapeHtml(linea.unidadesMalas) + '"' +
                                    ' data-observaciones="' + escapeHtml(linea.observaciones) + '">' +
                                    '<img src="/public/build/img/icons/editar.svg" alt="editar"></button>' +
                                    '<button type="button" class="btnEliminarTabulacionAcondicionamientoBtn" data-id="' + linea.idLineaReporteAcondicionamiento + '">' +
                                    '<img src="/public/build/img/icons/papelera.svg" alt="eliminar"></button>';
                            }
                            htmlLineas += '<tr>' +
                                '<td>' + escapeHtml(linea.nombreUsuario) + '</td>' +
                                '<td>' + escapeHtml(linea.horaInicio) + '</td>' +
                                '<td>' + escapeHtml(linea.horaFin) + '</td>' +
                                '<td>' + num(linea.cantidadTrabajada) + '</td>' +
                                '<td>' + num(linea.unidadesBuenas) + '</td>' +
                                '<td>' + num(linea.unidadesOtraDisposicion) + '</td>' +
                                '<td>' + num(linea.unidadesMalas) + '</td>' +
                                '<td>' + escapeHtml(linea.observaciones) + '</td>' +
                                '<td class="contAccionesTabla">' + acciones + '</td>' +
                                '</tr>';
                        });
                        tbody.innerHTML = htmlLineas;
                    }
                }

                // ── Resumen ───────────────────────────────────────────────────────
                const contResumen = document.getElementById('contResumenAcondicionamiento');
                if (contResumen) {
                    const participacion = resumen.participacionOperario || [];
                    let htmlParticipacion = '<p class="sinDatos">Sin participación registrada.</p>';
                    if (participacion.length > 0) {
                        let filas = '';
                        participacion.forEach(function (p) {
                            filas += '<tr><td>' + escapeHtml(p.nombreUsuario) + '</td><td>' + num(p.cantidadTrabajada) + '</td></tr>';
                        });
                        htmlParticipacion = '<table class="tablaModal"><thead><tr><th>Operario</th><th>Cant. trabajada</th></tr></thead><tbody>' + filas + '</tbody></table>';
                    }
                    contResumen.innerHTML =
                        '<div class="gridResumenAcondicionamiento">' +
                        '<div class="gridUnidades">' +
                        '<div class="cardResumen"><span>Total trabajado</span><strong>' + num(resumen.totalTrabajado) + '</strong></div>' +
                        '<div class="cardResumen"><span>Total buenas</span><strong>' + num(resumen.totalBuenas) + '</strong></div>' +
                        '<div class="cardResumen"><span>Otra disposición</span><strong>' + num(resumen.totalOtraDisposicion) + '</strong></div>' +
                        '<div class="cardResumen"><span>Total malas</span><strong>' + num(resumen.totalMalas) + '</strong></div>' +
                        '<div class="cardResumen"><span>Cantidad faltante</span><strong>' + num(resumen.cantidadFaltante) + '</strong></div>' +
                        '</div>' +
                        '<div class="gridPorcentaje">' +
                        '<div class="cardResumen"><span>% Cumplimiento</span><strong>' + num(resumen.porcentajeCumplimiento) + '%</strong></div>' +
                        '<div class="cardResumen"><span>% Buenas</span><strong>' + num(resumen.porcentajeBuenas) + '%</strong></div>' +
                        '<div class="cardResumen"><span>% Malas</span><strong>' + num(resumen.porcentajeMalas) + '%</strong></div>' +
                        '</div>' +
                        '</div>' +
                        '<div class="contParticipacionOperario">' +
                        '<h4>Participación por operario</h4>' +
                        htmlParticipacion +
                        '</div>';
                }

                // ── Activar primera pestaña si ninguna está seleccionada ─────────
                const grupoEtiquetas = modal.querySelector('#multiEtiquetaAcondicionamiento');
                const pestañaActiva = grupoEtiquetas ? grupoEtiquetas.querySelector('.etiquetaSelect') : null;
                if (!pestañaActiva && grupoEtiquetas) {
                    const primerBoton = grupoEtiquetas.querySelector('button');
                    if (primerBoton) primerBoton.classList.add('etiquetaSelect');
                    const canvaInfo = document.getElementById('canvaInfoGeneralAcondicionamiento');
                    if (canvaInfo) canvaInfo.classList.remove('oculto');
                }
            })
            .catch(function (error) {
                console.error('Error en la solicitud:', error);
                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('No se pudo cargar la información del reporte.', 'alerta-roja');
                } else {
                    alert('No se pudo cargar la información del reporte.');
                }
            });
    };

    // ─── Abrir modal desde tarjeta de trabajo asignado o tabla de periodo ────────
    document.addEventListener('click', function (e) {
        const target = e.target.closest('.btnVerReporte');
        if (target && target.getAttribute('data-modal') === 'modalProduccionAcondicionamiento') {
            const idReporte = target.getAttribute('data-id');
            if (idReporte) window.actualizarModalReporteAcondicionamiento(idReporte);
        }
    });

    // ─── Reactivar una orden finalizada (solo administrador) ────────────────────
    document.addEventListener('click', function (e) {
        const btnReactivar = e.target.closest('#btnReactivarReporteAcondicionamiento');
        if (!btnReactivar) return;

        const idReporte = btnReactivar.getAttribute('data-id');
        if (!idReporte) return;

        if (!window.confirm('¿Deseas reactivar esta orden de trabajo? El equipo podrá registrar y modificar tabulaciones nuevamente.')) {
            return;
        }

        btnReactivar.disabled = true;
        btnReactivar.setAttribute('aria-busy', 'true');
        const spinner = btnReactivar.querySelector('.spinner');
        if (spinner) spinner.style.display = 'inline-block';

        fetch('/api/acondicionamiento/reactivar', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'idEncabezadoReporteAcondicionamiento=' + encodeURIComponent(idReporte)
        })
            .then(function (respuesta) {
                return respuesta.json().then(function (json) {
                    return { respuesta: respuesta, json: json };
                });
            })
            .then(function (datosRespuesta) {
                const respuesta = datosRespuesta.respuesta;
                const json = datosRespuesta.json;

                if (!respuesta.ok || !json) {
                    let mensajeHttp = 'No fue posible reactivar la orden de trabajo.';
                    if (json && Array.isArray(json.errors) && json.errors.length > 0 && json.errors[0].message) {
                        mensajeHttp = json.errors[0].message;
                    }
                    throw new Error(mensajeHttp);
                }

                const resultado = json.result;
                if (!resultado) {
                    throw new Error('El servidor no devolvió un resultado válido.');
                }

                if (resultado.hayErrores) {
                    let mensajeValidacion = 'No fue posible reactivar la orden de trabajo.';
                    if (Array.isArray(resultado.errores) && resultado.errores.length > 0 && resultado.errores[0].mensaje) {
                        mensajeValidacion = resultado.errores[0].mensaje;
                    }
                    throw new Error(mensajeValidacion);
                }

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta(resultado.mensaje || 'Orden de trabajo reactivada correctamente.', 'alerta-verde');
                }

                if (typeof window.actualizarModalReporteAcondicionamiento === 'function') {
                    window.actualizarModalReporteAcondicionamiento(idReporte);
                }

                const params = new URLSearchParams(window.location.search);
                if (typeof window.actualizarTablaAcondicionamientoPeriodo === 'function') {
                    window.actualizarTablaAcondicionamientoPeriodo(params.get('mes'), params.get('año'));
                }
                if (window.location.pathname === '/zona-trabajo' && typeof window.actualizarZonaTrabajo === 'function') {
                    window.actualizarZonaTrabajo();
                }
            })
            .catch(function (error) {
                const mensaje = error && error.message
                    ? error.message
                    : 'Error al conectar con el servidor.';

                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta(mensaje, 'alerta-roja');
                } else {
                    alert(mensaje);
                }
            })
            .finally(function () {
                btnReactivar.disabled = false;
                btnReactivar.removeAttribute('aria-busy');
                if (spinner) spinner.style.display = 'none';
            });
    });

    // ─── Propagar el id del reporte activo al modal de agregar tabulación ────────
    document.addEventListener('click', function (e) {
        const btnTabulacion = e.target.closest('#btnAgregarTabulacionAcondicionamiento');
        if (!btnTabulacion) return;

        const inputIdReporte = document.getElementById('idReporteAcondicionamiento');
        const idReporte = inputIdReporte ? inputIdReporte.value : '';
        if (!idReporte) return;

        set('idReporteAgregarTabulacionAcondicionamiento', idReporte);
    });

    // ─── Abrir modal de edición de tabulación con datos precargados ──────────────
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.btnEditarTabulacionAcondicionamiento');
        if (!btn) return;

        const modalEditar = document.querySelector('#modalEditarTabulacionAcondicionamiento');
        if (!modalEditar) return;

        set('idLineaEditarTabulacionAcondicionamiento', btn.getAttribute('data-id'));
        set('horaInicioEditarTabulacionAcondicionamiento', btn.getAttribute('data-hora-inicio'));
        set('horaFinEditarTabulacionAcondicionamiento', btn.getAttribute('data-hora-fin'));
        set('cantidadTrabajadaEditarTabulacionAcondicionamiento', btn.getAttribute('data-cantidad-trabajada'));
        set('unidadesBuenasEditarTabulacionAcondicionamiento', btn.getAttribute('data-unidades-buenas'));
        set('unidadesOtraDisposicionEditarTabulacionAcondicionamiento', btn.getAttribute('data-unidades-otra'));
        set('unidadesMalasEditarTabulacionAcondicionamiento', btn.getAttribute('data-unidades-malas'));
        set('observacionesEditarTabulacionAcondicionamiento', btn.getAttribute('data-observaciones'));

        modalEditar.classList.add('modal--show');
    });

    // ─── Abrir modal de eliminación de tabulación ────────────────────────────────
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.btnEliminarTabulacionAcondicionamientoBtn');
        if (!btn) return;

        const modalEliminar = document.querySelector('#modalEliminarTabulacionAcondicionamiento');
        if (!modalEliminar) return;

        set('idLineaEliminarTabulacionAcondicionamiento', btn.getAttribute('data-id'));
        modalEliminar.classList.add('modal--show');
    });

    // ─── Abrir modal de eliminación de la orden de trabajo completa ──────────────
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('#btnEliminarReporteAcondicionamiento');
        if (!btn) return;

        const modalEliminarReporte = document.querySelector('#modalEliminarReporteAcondicionamiento');
        if (!modalEliminarReporte) return;

        set('idReporteEliminarAcondicionamiento', btn.getAttribute('data-id'));
    });

    // ─── Botón duplicar: precargar modal de duplicado ────────────────────────────
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('.btnDuplicarReporteAcondicionamiento');
        if (!btn) return;

        const idReporte = btn.getAttribute('data-id');
        if (!idReporte) return;

        fetch(`/api/acondicionamiento/infoReporte?idReporte=${idReporte}`, requestOptions)
            .then(function (res) { return res.json(); })
            .then(function (result) {
                const data = result.result;
                if (!data || !data.encabezado) return;
                const encabezado = data.encabezado;

                const modalDuplicar = document.querySelector('#modalDuplicarOrdenAcondicionamiento');
                if (!modalDuplicar) return;

                set('idReporteOrigenDuplicarAcondicionamiento', idReporteAcondicionamiento(encabezado) || idReporte);
                set('codigoArticuloDuplicarAcondicionamiento', txt(encabezado.codigoArticulo));
                set('descripcionArticuloDuplicarAcondicionamiento', txt(encabezado.descripcionArticulo));
                set('nombreActividadDuplicarAcondicionamiento', txt(encabezado.nombreActividad));
                set('fechaTrabajoDuplicarAcondicionamiento', encabezado.fechaTrabajo);
                set('numeroOfDuplicarAcondicionamiento', encabezado.numeroOf);
                set('numeroPedidoDuplicarAcondicionamiento', encabezado.numeroPedido);
                set('unidadesRequeridasDuplicarAcondicionamiento', encabezado.unidadesRequeridas);
                set('cantidadRecibidaDuplicarAcondicionamiento', encabezado.cantidadRecibida);
                set('cantidadDespachoDuplicarAcondicionamiento', encabezado.cantidadDespacho);
                set('observacionesDuplicarAcondicionamiento', encabezado.observaciones);

                // Precargar el equipo de la orden original; el admin puede ajustarlo
                if (window.selectorEquipoDuplicarAcondicionamiento) {
                    window.selectorEquipoDuplicarAcondicionamiento.precargar(data.equipo || []);
                }

                modalDuplicar.classList.add('modal--show');
            })
            .catch(function () {
                alert('No se pudo cargar la información para duplicar.');
            });
    });

    // ─── Construir y abrir la vista de impresión de la orden finalizada ──────────
    function abrirVentanaImpresionOrdenAcondicionamiento(data) {
        const encabezado = data.encabezado;
        const equipo = data.equipo || [];
        const lineas = data.lineas || [];
        const resumen = data.resumen || {};

        let filasEquipo = '';
        equipo.forEach(function (item) {
            filasEquipo += '<tr><td>' + escapeHtml(item.nombreCargo) + '</td><td>' + escapeHtml(item.nombreCompletoUsuario) + '</td></tr>';
        });
        if (!filasEquipo) {
            filasEquipo = '<tr><td colspan="2">Sin operarios asignados.</td></tr>';
        }

        let filasLineas = '';
        lineas.forEach(function (linea) {
            filasLineas += '<tr>' +
                '<td>' + escapeHtml(linea.nombreUsuario) + '</td>' +
                '<td>' + escapeHtml(linea.horaInicio) + '</td>' +
                '<td>' + escapeHtml(linea.horaFin) + '</td>' +
                '<td>' + num(linea.cantidadTrabajada) + '</td>' +
                '<td>' + num(linea.unidadesBuenas) + '</td>' +
                '<td>' + num(linea.unidadesOtraDisposicion) + '</td>' +
                '<td>' + num(linea.unidadesMalas) + '</td>' +
                '<td>' + escapeHtml(linea.observaciones) + '</td>' +
                '</tr>';
        });
        if (!filasLineas) {
            filasLineas = '<tr><td colspan="8">No hay registros de producción.</td></tr>';
        }

        const htmlOrden = '<!DOCTYPE html><html lang="es"><head><meta charset="UTF-8">' +
            '<title>Orden de trabajo OF ' + escapeHtml(encabezado.numeroOf || '') + '</title>' +
            '<style>' +
            'body{font-family:Arial,Helvetica,sans-serif;color:#1e1e1e;margin:2rem;}' +
            'h1{color:#0b1f3e;font-size:1.3rem;margin-bottom:.2rem;}' +
            'h2{color:#0b1f3e;font-size:1rem;margin-top:1.5rem;border-bottom:2px solid #0b1f3e;padding-bottom:.3rem;}' +
            '.gridInfoOrden{display:grid;grid-template-columns:repeat(2,1fr);gap:.5rem 2rem;margin-top:1rem;}' +
            '.gridInfoOrden div{font-size:.9rem;}' +
            '.gridInfoOrden span{font-weight:bold;display:block;color:#333333;}' +
            'table{width:100%;border-collapse:collapse;margin-top:.5rem;}' +
            'th,td{border:1px solid #e2e4e5;padding:.4rem;font-size:.85rem;text-align:left;}' +
            'th{background:#f7f8fb;}' +
            '.resumenOrden{display:flex;gap:1.5rem;flex-wrap:wrap;margin-top:.5rem;}' +
            '.resumenOrden div{font-size:.9rem;}' +
            '@media print{body{margin:1rem;}}' +
            '</style></head><body>' +
            '<h1>Orden de trabajo - OF ' + escapeHtml(encabezado.numeroOf || '') + '</h1>' +
            '<p>' + escapeHtml(encabezado.nombreActividad || '') + ' - ' + fecha(encabezado.fechaTrabajo) + '</p>' +
            '<h2>Información general</h2>' +
            '<div class="gridInfoOrden">' +
            '<div><span>Número de pedido:</span>' + txt(encabezado.numeroPedido) + '</div>' +
            '<div><span>Cliente:</span>' + txt(encabezado.nombreSap) + '</div>' +
            '<div><span>CMN / código cliente:</span>' + txt(encabezado.codigoSap) + '</div>' +
            '<div><span>Código artículo:</span>' + txt(encabezado.codigoArticulo) + '</div>' +
            '<div><span>Descripción artículo:</span>' + txt(encabezado.descripcionArticulo) + '</div>' +
            '<div><span>Lote de importación:</span>' + txt(encabezado.loteImportacion) + '</div>' +
            '<div><span>Lote de trabajo:</span>' + txt(encabezado.loteTrabajo) + '</div>' +
            '<div><span>Detalle de actividad:</span>' + txt(encabezado.detalleActividad) + '</div>' +
            '<div><span>Unidades requeridas:</span>' + num(encabezado.unidadesRequeridas) + '</div>' +
            '<div><span>Cantidad recibida:</span>' + num(encabezado.cantidadRecibida) + '</div>' +
            '<div><span>Cantidad de despacho:</span>' + num(encabezado.cantidadDespacho) + '</div>' +
            '<div><span>Creado por:</span>' + txt(encabezado.nombreCreadoPor) + '</div>' +
            '</div>' +
            '<h2>Equipo de trabajo</h2>' +
            '<table><thead><tr><th>Cargo</th><th>Operario</th></tr></thead><tbody>' + filasEquipo + '</tbody></table>' +
            '<h2>Tabulación</h2>' +
            '<table><thead><tr><th>Operario</th><th>Hora inicio</th><th>Hora fin</th><th>Cant. trabajada</th><th>Buenas</th><th>Otra disp.</th><th>Malas</th><th>Observaciones</th></tr></thead><tbody>' + filasLineas + '</tbody></table>' +
            '<h2>Resumen</h2>' +
            '<div class="resumenOrden">' +
            '<div><span>Total trabajado:</span>' + num(resumen.totalTrabajado) + '</div>' +
            '<div><span>Total buenas:</span>' + num(resumen.totalBuenas) + '</div>' +
            '<div><span>Otra disposición:</span>' + num(resumen.totalOtraDisposicion) + '</div>' +
            '<div><span>Total malas:</span>' + num(resumen.totalMalas) + '</div>' +
            '<div><span>Cantidad faltante:</span>' + num(resumen.cantidadFaltante) + '</div>' +
            '<div><span>% Cumplimiento:</span>' + num(resumen.porcentajeCumplimiento) + '%</div>' +
            '</div>' +
            '<script>window.onload = function () { window.print(); };<' + '/script>' +
            '</body></html>';

        const ventanaOrden = window.open('', '_blank');
        if (!ventanaOrden) {
            alert('El navegador bloqueó la ventana de impresión. Habilita las ventanas emergentes para este sitio.');
            return;
        }
        ventanaOrden.document.open();
        ventanaOrden.document.write(htmlOrden);
        ventanaOrden.document.close();
    }

    // ─── Botón: abrir la orden de trabajo finalizada en vista de impresión ──────
    document.addEventListener('click', function (e) {
        const btn = e.target.closest('#btnAbrirOrdenTrabajoAcondicionamiento');
        if (!btn) return;

        const inputIdReporte = document.getElementById('idReporteAcondicionamiento');
        const idReporte = inputIdReporte ? inputIdReporte.value : '';
        if (!idReporte) return;

        fetch(`/api/acondicionamiento/infoReporte?idReporte=${idReporte}`, requestOptions)
            .then(function (res) { return res.json(); })
            .then(function (result) {
                const data = result.result;
                if (!data || !data.encabezado) return;
                abrirVentanaImpresionOrdenAcondicionamiento(data);
            })
            .catch(function () {
                if (typeof lanzarAlerta === 'function') {
                    lanzarAlerta('No se pudo abrir la orden de trabajo.', 'alerta-roja');
                } else {
                    alert('No se pudo abrir la orden de trabajo.');
                }
            });
    });
}
